import { createAction } from '@reduxjs/toolkit';
import { SmoMoonList } from '../../../../Models/Smo/SmoMoonList';

const resetState = createAction('MOON_LISTS_RESET_STATE');
const getMoonLists = createAction('MOON_LISTS_GET_MOON_LISTS');
const setPopularMoonLists = createAction<SmoMoonList[]>('MOON_LISTS_SET_POPULAR');
const setAllMoonLists = createAction<SmoMoonList[]>('MOON_LISTS_SET_ALL_MOON_LISTS');
const setSearch = createAction<string>('MOON_LISTS_SET_SEARCH');
const setSearchResults = createAction<SmoMoonList[]>('MOON_LISTS_SET_SEARCH_RESULTS');

export default {
  resetState,
  getMoonLists,
  setPopularMoonLists,
  setAllMoonLists,
  setSearch,
  setSearchResults
};
